import React from "react";

import { useAppType, useLocation } from "utils";

import { ErrorBoundary, Layout, SelectLanguage } from "components";

export const ScreenSplit = ({ sideChildren, children, hideSelectLanguage = false, showSiderOnMobile = false }) => {
  const { Sider, Header, Content } = Layout;
  const appType = useAppType();
  const location = useLocation();

  if (!appType.desktop && !showSiderOnMobile) {
    return children;
  }

  const HeaderSplitView = () => (
    <section className={`container ${location.pathname.includes("/confirm-account") ? "tiny" : "tiniest"}`}>
      <Header className="split-screen header">
        <ErrorBoundary>
          <SelectLanguage placement="bottomRight" />
        </ErrorBoundary>
      </Header>
    </section>
  );

  return (
    <Layout>
      <Sider className="split-screen sider" width="50%">
        {sideChildren}
      </Sider>
      <div className="split-screen children">
        {!hideSelectLanguage ? <HeaderSplitView /> : null}
        <Content>{children}</Content>
      </div>
    </Layout>
  );
};
